import { type Ref } from 'vue';

export function handleTouchStart({
    elementRef,
    event,
    isSwippingRef,
    onClose,
    threshold = 100,
}: {
    elementRef: Ref<HTMLElement | null>;
    event: TouchEvent;
    isSwippingRef: Ref<boolean>;
    onClose: () => void;
    threshold?: number;
}) {
    const startY = event.touches[0].clientY;
    let currentTranslate = 0;

    isSwippingRef.value = true;

    function handleTouchMove(e: TouchEvent): void {
        if (!elementRef.value) return;

        const currentY = e.touches[0].clientY;
        const diff = currentY - startY;

        if (diff > 0) {
            currentTranslate = diff;
            elementRef.value.style.transform = `translateY(${currentTranslate}px)`;
            e.preventDefault();
        }
    }

    function handleTouchEnd() {
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);

        if (!elementRef.value) return;

        if (currentTranslate > threshold) {
            onClose();
        } else {
            // Animation de retour en position initiale
            elementRef.value.style.transition = 'transform 0.3s ease-out';
            elementRef.value.style.transform = '';

            // Réinitialisation après la fin de l'animation
            setTimeout(() => {
                if (elementRef.value) {
                    elementRef.value.style.transition = '';
                }
                isSwippingRef.value = false;
            }, 300);
        }

        currentTranslate = 0;
    }

    document.addEventListener('touchmove', handleTouchMove, { passive: false });
    document.addEventListener('touchend', handleTouchEnd);
}
